import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import Loadable from '../../base/components/Template/Loadable/Loadable'
export const proveedorRouteMap = {
  gestion: {
    path: `/proveedor/gestion`,
    name: 'Proveedores',
  },
  nuevo: {
    path: `/proveedor/nuevo`,
    name: 'Nuevo Proveedor',
  },
  modificar: {
    path: `/proveedor/modificar`,
    name: 'Modificar Proveedor',
  },
}

const AppProveedores = Loadable(lazy(() => import('./view/Proveedores')))

const proveedorRoutes = [
  {
    path: proveedorRouteMap.gestion.path,
    element: <AppProveedores />,
    auth: authRoles.admin,
  },
  // {
  //   path: proveedorRouteMap.modificar.path,
  // }
]

export default proveedorRoutes
